import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../config/firebase';

const surveysCollection = 'surveys';

export const addSurveyResponse = async (userId, surveyResponse) => {
  try {
    const docRef = await addDoc(collection(db, surveysCollection), {
      userId,
      ...surveyResponse,
      createdAt: serverTimestamp(),
      submittedAt: new Date().toISOString()
    });
    return docRef.id;
  } catch (error) {
    console.error('Error adding survey response:', error);
    throw error;
  }
}; 